import React, { useContext } from 'react';

import Dashboard from "@base/Dashboard";
import Main from "@base/Container";

import { MenuContext } from '@contexts/MenuContext';

const LayoutPrivate = (props) => {
  const {open, setOpen} = useContext(MenuContext);

  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);

  return (
    <>
      <Dashboard
        open={open}
        handleDrawerOpen={handleDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        handleLogout={props.handleLogout}
        darkMode={props.darkMode}
        setDarkMode={props.setDarkMode}
      />
      <Main open={open} >
        {props.children}
      </Main>
    </>
  )
}

export default LayoutPrivate;
